import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Tooltip from "../../elements/tooltip/Tooltip";
import IndicatorCircle from "./IndicatorCircle";
import AriaText from "../aria/AriaText";
class Indicator extends React.Component {
    render() {
        const className = classNames("gui-indicator", `gui-indicator--${this.props.placement}`);
        const content = (React.createElement("span", null,
            React.createElement(IndicatorCircle, { type: this.props.type, whiteBorder: this.props.whiteBorder, small: this.props.small }),
            this.props.description ? React.createElement(AriaText, null, this.props.description) : null));
        return (React.createElement("span", { className: className }, this.props.useTooltip ? (React.createElement(Tooltip, { tooltip: this.props.description, placement: this.props.tooltipPlacement }, content)) : (content)));
    }
}
Indicator.propTypes = {
    description: PropTypes.string,
    type: PropTypes.oneOf(["warning", "error", "important"]),
    placement: PropTypes.oneOf(["left", "right", "top", "bottom"]),
    small: PropTypes.bool,
    whiteBorder: PropTypes.bool
};
Indicator.defaultProps = {
    type: "important",
    placement: "left",
    whiteBorder: true,
    small: false
};
export default Indicator;
//# sourceMappingURL=Indicator.js.map